import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive } from 'vue';
import { ComplianceStatus, OnboardingStatusReport } from 'ah-api-gateways';
import { sum } from 'lodash';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingStatuses',
  setup(__props) {

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadCounts') {
      loadCounts();
    }
  },
});

const state = reactive<{
  counts: OnboardingStatusReport[] | null;
}>({
  counts: null,
});

function loadCounts() {
  requestManager.manager.new('loadCounts', getServices().client.getClientOnboardingReportStatus()).subscribe((r) => {
    state.counts = r.summary;
  });
}

const total = computed(() => {
  if (!state.counts) return 0;
  return sum(state.counts.filter((c) => !!c.status).map((c) => c.total));
});

function findCount(status: ComplianceStatus) {
  if (!state.counts) return 0;
  return state.counts.find((c) => c.status === status)?.total || 0;
}

loadCounts();

return { __sfc: true,requestManager, state, loadCounts, total, findCount, ComplianceStatus }
}

})